import React from 'react';
import {
	FeedbackCollectorButton,
	EntryKeys,
	ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT,
} from '@atlassian/jira-feedback-collector';

export const FEEDBACK_COLLECTOR_LOCATION = 'project-pages.project-directories.versions';

export const FeedbackButton = () => {
	const feedbackContextEntries = [
		{ id: EntryKeys.FEEDBACK_COLLECTOR_LOCATION, value: FEEDBACK_COLLECTOR_LOCATION },
	];

	return (
		<FeedbackCollectorButton
			entrypointId={ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT}
			feedbackContext={feedbackContextEntries}
		/>
	);
};
